// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YaCQo","col":"styles_col__2LOoM"};